// extracted by mini-css-extract-plugin
module.exports = {"root":"Completed_root__30HPC","label":"Completed_label__3g1lH"};